<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Download Templates</h5>
    <div class="mr-0 d-flex flex-column align-items-center">

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Select Template</label>
        <ng-select class="form-select" [(ngModel)]="template" [ngModelOptions]="{ standalone: true }"
          (change)="onTemplateSelected()">
          <ng-option selected value="" disabled>Select Template</ng-option>
          <ng-option value="QU">Question Upload</ng-option>
          <!-- <ng-option value="QCU">Question Category Upload</ng-option> -->
          <ng-option value="ECE">Exam Candidates Import</ng-option>
          <ng-option value="CES">Candidate Examination Schedule</ng-option>
          <ng-option value="IPFE">Import Passwords From Excel.xlsx</ng-option>
        </ng-select>
      </div>

      <div class="mb-3 mr-0 col-md-10" *ngIf="template==='QU'">
        <label class="form-label">Select Template</label>
        <ng-select class="form-select" [(ngModel)]="questionFormat" [ngModelOptions]="{ standalone: true }"
          (change)="onFormartSelected()">
          <ng-option selected value="" disabled>Select Format</ng-option>
          <ng-option value="Format1">Format1</ng-option>
          <ng-option value="Format2">Format2</ng-option>
          <ng-option value="Excel">Excel</ng-option>
        </ng-select>
      </div>
      <button #tempDownload class="btn btn-primary btn-lg col-md-10" rel="noopener noreferrer"
        (click)="downloadTemplate()">
        Download </button>
    </div>
  </div>
</div>